import { getLogger } from "@/utils/logger";

/**
 * The one wording and recovery for a component chunk that will not download
 * (#4053), shared by `ChunkLoadError.vue` and `ChunkLoadErrorDialog.vue`.
 *
 * Recovery is a reload rather than a retry: a browser memoises a failed module
 * fetch against the same URL, so asking for it again returns the same failure
 * without going near the network. The router answers a failed *route* chunk the
 * same way, with a reload (`src/router/index.ts`).
 */
export const CHUNK_LOAD_ERROR_TITLE = "This part of the page could not be loaded";

export const CHUNK_LOAD_ERROR_BODY = "Its code did not download. Reloading the page usually fixes it.";

export const CHUNK_LOAD_ERROR_RELOAD_LABEL = "Reload page";

const logger = getLogger("ChunkLoadError");

/** Record the rejection the officer is being shown, which the DOM cannot carry. */
export function logChunkLoadError(error?: unknown): void {
  if (error === undefined) return;
  logger.error("A component chunk would not download", error);
}

export function reloadPage(): void {
  window.location.reload();
}
